import { useEffect } from 'react';
import { includes } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader, Dialog } from 'components';
import Panel from 'components/atoms/GefMui/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import { USER_ROLES } from 'constants/general';
import MODALS from 'constants/modals';
import PAGES from 'constants/pages';
import fetch from 'features/common/fetch';
import { getWasFetched } from 'features/common/fetch/selectors';
import { subheaders } from 'features/common/Subheader/constants';
import contactFeedback from 'features/views/contactFeedback';
import contactList from 'features/views/contactList';
import contacts from 'features/views/contacts';
import { prefillFormWithPreviousData } from 'features/views/contacts/actions';
import { getCurrentRole } from 'features/views/user/selectors';
import BruttoProductionModal from 'pages/BruttoProductionModal';

import Filter from './components/Filter';
import Table from './components/Table';
import Toolbar from './components/Toolbar';
import ContactTakeModal from './modals/ContactTakeModal';

export const Contacts = () => {
	const dispatch = useDispatch();

	const currentRole = useSelector(getCurrentRole);
	const wasFetched = useSelector(getWasFetched(`${fetch.constants.urls.contactList}.list`));
	const initiallyOpen = !includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ]);

	useEffect(() => {
		if (!wasFetched) {
			dispatch(contactList.actions.startupContacts());
		}
	}, [dispatch, wasFetched]);

	useEffect(() => {
		dispatch(prefillFormWithPreviousData());
	}, [dispatch]);

	const floatingDialogs = (
		<>
			<Dialog mui name={contactList.constants.REPORT_NOT_FOUND_DIALOG}>
				{getLabelMessage('campaigns:reportNotFound')}
			</Dialog>
			<Dialog mui name={contactFeedback.constants.dialogs.PARTNER_LOCKED_DIALOG}>
				{getLabelMessage('contactDetail:partnerLocked')}
			</Dialog>
			<Dialog mui name={contactFeedback.constants.dialogs.PARTNER_NOT_FOUND_IN_CCD}>
				{getLabelMessage('contactDetail:partnerNotFoundInCCD')}
			</Dialog>
			<Dialog mui name={contacts.constants.dialogs.TOO_MANY_CONTACTS_FOR_PRINT}>
				{getLabelMessage('contacts:tooManyContactsForPrint')}
			</Dialog>
		</>
	);

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.user}>
			<Panel screenName={PAGES.contacts.name} screenId={PAGES.contacts.id} floatingDialogs={floatingDialogs}>
				<BruttoProductionModal id={MODALS.brutto_production} />
				<ContactTakeModal id={MODALS.contact_take} />
				<PaperWithToolbar
					toggledElement={<Filter />}
					toolbar={<Toolbar />}
					collapsibleProps={{ id: subheaders.contacts, initiallyOpen }}
				>
					<Table />
				</PaperWithToolbar>
			</Panel>
		</ComponentLoader>
	);
};

export default Contacts;
